(function () {
    if (embedJsLoaded) {
        return;
    }

    window.feedspaceAppURL = '__FEEDSPACE_APP_URL__';
    window.feedspaceApiURL = '__FEEDSPACE_API_URL__';
    window.feedspaceWebURL = '__FEEDSPACE_WEB_URL__';
    window.feedspaceJsURL = '__FEEDSPACE_JS_URL__';
    window.feedspaceAppEnv = '__FEEDSPACE_APP_ENV__';

    window.feedspaceEmbedDivs = [];
    var embedJsLoaded = false;

    const initFeedspaceEmbed = () => {
        var dataIDs = [];
        var dataPreviewArray = [];
        var embedElementsMap = new Map(); // Store DOM element references
        var embedDivs = document.querySelectorAll('div.feedspace-embed');

        if (embedDivs.length == 0) {
            return;
        }

        embedDivs.forEach(function (embedDiv) {
            var dataId = embedDiv.getAttribute('data-id');
            var dataPreview = embedDiv.getAttribute('data-preview');
            if (window.feedspaceEmbedDivs.includes(dataId)) {
                return;
            }
            dataIDs.push(dataId);
            dataPreviewArray[dataId] = dataPreview;
            embedElementsMap.set(dataId, embedDiv); // Store DOM element reference
            window.feedspaceEmbedDivs.push(dataId);
            updateLoader(embedDiv, '');
        });
        fetchDataForDataIDs(dataIDs, dataPreviewArray, embedElementsMap);
    };

    function updateLoader(embedDiv, text = 'Loading...') {
        let loadingDiv = embedDiv.querySelector('.feedspace-embed-loading');
        if (!loadingDiv) {
            loadingDiv = document.createElement('div');
            loadingDiv.className = 'feedspace-embed-loading';
            loadingDiv.style =
                'font-size: 18px; min-height: 160px; display: flex; justify-content: center; align-items: center;';
            embedDiv.appendChild(loadingDiv);
        }
        loadingDiv.innerHTML = text;
    }

    // Code to run after DOM is fully loaded
    function fsDisconnectObserver() {
        setTimeout(() => {
            observer.disconnect();
        }, 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fsDisconnectObserver);
    } else {
        fsDisconnectObserver();
    }

    const observer = new MutationObserver(initFeedspaceEmbed);
    observer.observe(document, { childList: true, subtree: true });
    embedJsLoaded = true;
    initFeedspaceEmbed();

    async function fetchDataForDataIDs(
        dataIDs,
        dataPreviewArray,
        embedElementsMap
    ) {
        var dataIDResponses = [];
        var builderJSArray = [];

        // Process all embeds in parallel
        const embedPromises = dataIDs.map(async dataId => {
            let dataIdElement = embedElementsMap.get(dataId);
            try {
                const promises = [];

                promises.push(loadBuilderScript(dataId));

                promises.push(loadData(dataId));

                const [, data] = await Promise.all(promises);

                dataIDResponses[dataId] = data;
                const builderJsName = data.builder_js;
                if (!builderJSArray.includes(builderJsName)) {
                    builderJSArray.push(builderJsName);
                }

                if (dataIdElement) {
                    hideLoader(dataIdElement);

                    feedspaceRender(builderJsName, dataIdElement, data);
                }
            } catch (error) {
                hideLoader(dataIdElement);

                console.error(`Error processing embed ${dataId}:`, error);
            }
        });

        // Wait for all embeds to complete
        await Promise.all(embedPromises);

        function buildDataURL(dataId, path = '') {
            return `${window.feedspaceApiURL}${dataId}${path}`;
        }

        function buildJsURL(fileName) {
            return `${window.feedspaceJsURL}${fileName}`;
        }

        async function loadBuilderScript(dataId) {
            const response = await fetch(buildDataURL(dataId, '/js'));

            const jsMeta = await response.json();

            try {
                const loader_text = jsMeta.loader_text ?? 'Loading...';
                const dataIdElement = embedElementsMap.get(dataId);
                if (dataIdElement && loader_text) {
                    updateLoader(dataIdElement, loader_text);
                }
            } catch (error) {
                console.error(`Error updating loader for ${dataId}:`, error);
            }

            await loadScript(jsMeta.builder_js);

            return jsMeta;
        }

        function hideLoader(dataIdElement) {
            const loadingElement = dataIdElement?.querySelector(
                '.feedspace-embed-loading'
            );

            if (!loadingElement) {
                return;
            }

            loadingElement.remove();
        }

        async function loadData(dataId) {
            let isPreview =
                dataPreviewArray[dataId] && dataPreviewArray[dataId] == 'on'
                    ? true
                    : false;
            let dataUrl = buildDataURL(dataId);
            if (isPreview) {
                dataUrl += '?preview=true';
            }

            const response = await fetch(dataUrl);

            if (!response.ok) {
                throw new Error(
                    `Failed to fetch data for ${dataId}: ${response.statusText}`
                );
            }

            return response.json();
        }

        async function loadScript(src) {
            let existingScript = Array.from(document.scripts).find(
                script => script.src === buildJsURL(src)
            );

            if (existingScript) {
                return;
            }

            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = buildJsURL(src);
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        }

        function feedspaceRender(js, dataIdElement, data) {
            js = js.substring(0, js.indexOf('.'));
            js = js.replace(/^\w/, c => c.toUpperCase());
            const methodName = 'feedspaceWOLInit' + js;

            if (typeof window[methodName] === 'function') {
                window[methodName](dataIdElement, data);
                
                // Initialize video optimization after widget is rendered
                setTimeout(() => {
                    initTwoStageVideoLoading(dataIdElement);
                    initAudioHoverLoading(dataIdElement);
                }, 300); // Small delay to ensure DOM is fully updated
            } else {
                console.error(
                    `Function ${methodName} is not defined on window object`
                );
            }
        }

        // Stage 1: Load video metadata when visible in viewport
        function initMetadataPreloadOnVisibility(container, targetPreload = 'metadata') {
            // Check if Intersection Observer is supported
            if (!('IntersectionObserver' in window)) {
                return;
            }

            // Create an Intersection Observer to detect when videos become visible
            const videoObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const video = entry.target;
                        // Only preload metadata if video hasn't been preloaded yet
                        if (video.getAttribute('preload') === 'none') {
                            video.setAttribute('preload', targetPreload);
                        }
                        // Unobserve the video to avoid repeated processing
                        videoObserver.unobserve(video);
                    }
                });
            }, {
                threshold: 0.1, // Trigger when at least 10% of the video is visible
                rootMargin: '50px' // Start preloading 50px before video enters viewport
            });

            // Observe all video elements within this container
            const videos = container.querySelectorAll('.feedspace-video');
            videos.forEach(video => {
                videoObserver.observe(video);
            });

            // Store observer reference for potential cleanup
            if (!window.feedspaceVideoObservers) {
                window.feedspaceVideoObservers = [];
            }
            window.feedspaceVideoObservers.push(videoObserver);
        }

        // Stage 2: Load full video content on hover (desktop) and touch (mobile)
        function initFullPreloadOnHover(container, targetPreload = 'auto') {
            // Find all video containers within this container
            const videoContainers = container.querySelectorAll('.feedspace-element-video-box');
            
            videoContainers.forEach(videoContainer => {
                const preloadVideo = () => {
                    const video = videoContainer.querySelector('.feedspace-video');
                    if (video) {
                        // Only preload full content if video is still on metadata or none
                        const currentPreload = video.getAttribute('preload');
                        if (currentPreload === 'none' || currentPreload === 'metadata') {
                            video.setAttribute('preload', targetPreload);
                        }
                    }
                };

                // Desktop: hover event
                videoContainer.addEventListener('mouseenter', preloadVideo, { once: true });
                
                // Mobile: touch events
                videoContainer.addEventListener('touchstart', preloadVideo, { once: true });
            });
        }

        // Two-stage video loading: metadata on visibility + full content on hover
        function initTwoStageVideoLoading(container) {
            try {
                // Check number of videos in container
                const videos = container.querySelectorAll('.feedspace-video');
                if (videos.length === 0) {
                    return;
                }

                // Stage 1: Load metadata when video becomes visible
                // If less than 5 video then set to auto
                if (videos.length < 5) {
                    initMetadataPreloadOnVisibility(container, 'auto');
                } else {
                    initMetadataPreloadOnVisibility(container, 'metadata');

                    // Stage 2: Load full content when user hovers
                    initFullPreloadOnHover(container);
                }
            } catch (error) {
                console.error('Error initializing two-stage video loading:', error);
            }
        }

        // Cleanup function for video observers (optional)
        function cleanupVideoObservers() {
            if (window.feedspaceVideoObservers) {
                window.feedspaceVideoObservers.forEach(observer => {
                    observer.disconnect();
                });
                window.feedspaceVideoObservers = [];
            }
        }

        // Expose cleanup function globally for manual cleanup if needed
        window.feedspaceCleanupVideoObservers = cleanupVideoObservers;

        // Audio loading on hover (desktop) and touch (mobile)
        function initAudioHoverLoading(container) {
            const audioContainers = container.querySelectorAll('.feedspace-element-audio-feed');
            
            audioContainers.forEach(audioContainer => {
                const preloadAudio = () => {
                    const audio = audioContainer.querySelector('.feedspace-audio');
                    if (audio && audio.getAttribute('preload') === 'none') {
                        audio.setAttribute('preload', 'auto');
                    }
                };

                // Desktop: hover event
                audioContainer.addEventListener('mouseenter', preloadAudio, { once: true });
                
                // Mobile: touch events
                audioContainer.addEventListener('touchstart', preloadAudio, { once: true });
            });
        }
    }
})();
